import React, { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Appearance } from '@stripe/stripe-js';

interface StripeProviderProps {
  children: React.ReactNode;
}

const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
  const stripePromise = useMemo(
    () => loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || ''),
    [],
  );

  const appearance: Appearance = {
    theme: 'stripe',
    variables: {
      colorPrimary: '#4967fd',
      colorBackground: '#ffffff',
      colorText: '#262626',
      colorDanger: '#df1b41',
      fontFamily: 'Inter, system-ui, sans-serif',
      spacingUnit: '4px',
      borderRadius: '8px',
      fontSizeBase: '16px',
      colorTextPlaceholder: '#7b7a7a',
    },
    rules: {
      '.Input': {
        border: '1px solid #d1d0d0',
        padding: '10px',
        fontSize: '16px',
        lineHeight: '24px',
      },
      '.Input:focus': {
        border: '1px solid #262626',
        boxShadow: 'none',
        outline: 'none',
      },
      '.Input--invalid': {
        border: '1px solid #df1b41',
        color: '#df1b41',
      },
      '.Label': {
        fontSize: '14px',
        fontWeight: '300',
        marginBottom: '6px',
        color: '#262626',
      },
      '.Error': {
        fontSize: '14px',
        color: '#df1b41',
        marginTop: '4px',
      },
    },
  };

  const options = {
    appearance,
    fonts: [
      {
        cssSrc:
          'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap',
      },
    ],
  };

  if (!stripePromise) {
    return <div>Payment system is not configured</div>;
  }

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
};

export default StripeProvider;
